<template>
  <div ref="contentKeyfactsElement" class="content-keyfacts grid-accordion">
    <h2 ref="titleElement" class="title">{{ data.title }}</h2>
    <div ref="itemsElement" class="items">
      <KeyfactsItem v-for="item in data.items" :key="item.id" :item="item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ContentKeyfactsFragment } from '#gql';
import useTextFadeIn from '~/utils/useTextFadeIn';
import KeyfactsItem from
  '~/components/content-modules/components/KeyfactsItem.vue';

const props = defineProps<{
  data: ContentKeyfactsFragment;
}>();

const contentKeyfactsElement = ref<null | HTMLElement>(null);
const titleElement = ref<null | HTMLElement>(null);
const itemsElement = ref<null | HTMLElement>(null);

useTextFadeIn(contentKeyfactsElement, [titleElement, itemsElement]);
</script>

<style scoped lang="scss">
.content-keyfacts {
  background-color: var(--background, var(--color-off-white));
}
</style>

<script lang="ts"></script>

<style scoped lang="scss">
.content-keyfacts {
  @media (--vs) {
    padding: 3rem var(--base-component-padding-inline-with-margins);
  }
  @media (--vl) {
    padding: 4rem var(--base-component-padding-inline-with-margins) 6rem
      var(--base-component-padding-inline-with-margins);
  }

  > .title {
    @include text-2xl(700);
    padding-bottom: 3.5rem;
  }
}
</style>
